import { ReactComponent as Export } from '@public/icons/external-link.svg';
import Icon from '../atoms/Icon';

const IconExport = (props) => <Icon as={Export} {...props} />;

IconExport.propTypes = Icon.propTypes;

export default IconExport;
